import React from "react";
import {
  Linking,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import TmcHeaderLogo from "../../../../assets/img/tmc-header-logo.png";
import CustomImage from "../custom-image";
import ButtonGradient from "../button-gradient";
import { button, FontFamily } from "../../styles/appStyles";
import { MENA_COUNTRIES } from "../../screens/home/data";
import isEmpty from "lodash/isEmpty";

function openUrl(url) {
  if (!url) {
    return;
  }

  if (typeof window !== "undefined") {
    window.location.href = url;
    return;
  }

  Linking.openURL(url);
}

function getButtonText(chargebee_billing_platform, locationInfo, token) {
  const isChargebeeIndia = chargebee_billing_platform === "chargebee_india";
  const isIndia = locationInfo?.countryInfo?.code === "IN";
  const isMiddleEast = MENA_COUNTRIES.includes(locationInfo?.countryInfo?.code);
  const inAedUser = isChargebeeIndia && isMiddleEast;
  const inUsdUser = isChargebeeIndia && !isMiddleEast && !isIndia;
  const isIndianUser = isIndia && (isChargebeeIndia || !token);
  const isMiddleEastUser = isMiddleEast && (isChargebeeIndia || !token);
  const isOverseasUser = !isIndia && !isMiddleEast && !isChargebeeIndia;

  if (isOverseasUser) {
    return "Subscribe for $50/year";
  } else if (isMiddleEastUser || inAedUser) {
    return "Subscribe for AED 100/year";
  } else if (inUsdUser) {
    return "Subscribe for $99/year";
  } else {
    return "Subscribe for ₹2999/year";
  }
}

export default function FooterSubscription(props) {
  const {
    links = [],
    token,
    userProfile,
    chargebee_billing_platform,
    locationInfo,
  } = props;

  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "/";
  const isSubscribedUser =
    !isEmpty(userProfile?.subscription) ||
    !isEmpty(userProfile?.team_subscription);

  const handleLogin = () => {
    openUrl(`/sign-in?redirect=${pathname}`);
  };

  const subscribeButtonClick = () => {
    openUrl(`/pricing/individual`);
  };

  const buttonText = getButtonText(
    chargebee_billing_platform,
    locationInfo,
    token,
  );

  return (
    <View style={styles.card}>
      <View style={styles.logoWrap}>
        <CustomImage
          source={
            "https://tmcstage-sgp-public.s3.ap-southeast-1.amazonaws.com/next2/_next/static/media/tmc-header-logo.2674f4de.png"
          }
          require={true}
          resizeMode="contain"
          className={"about-author-img"}
          altText={"TMC Logo"}
        />
      </View>

      <Text style={styles.description}>
        Smarter every morning, with original and independent journalism.
      </Text>

      {!isSubscribedUser ? (
        <View style={styles.buttonWrap}>
          <ButtonGradient
            title={buttonText}
            rootStyle={{
              btnWrapper: [button.primaryGradient, styles.subscribeButton],
              btnText: [button.primaryGradientText, styles.subscribeButtonText],
            }}
            paddingOverride={true}
            onClick={subscribeButtonClick}
            darkMode={props.darkMode}
            isNewGradiant={true}
            fullWidth={true}
          />
        </View>
      ) : null}

      {!token ? (
        <TouchableOpacity
          activeOpacity={0.85}
          onPress={handleLogin}
          style={styles.loginButton}
        >
          <Text style={styles.loginButtonText}>LOGIN</Text>
        </TouchableOpacity>
      ) : null}

      <View style={styles.links}>
        {links?.map((item) => (
          <TouchableOpacity
            activeOpacity={0.8}
            key={item.name}
            onPress={() => openUrl(item.url)}
            style={styles.linkItem}
          >
            <Text style={styles.linkText}>{item.name}</Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    maxWidth: 240,
    width: "100%",
  },
  logoWrap: {
    height: 50,
    maxWidth: 150,
    position: "relative",
    width: "100%",
  },
  logo: {
    height: 50,
    width: 150,
  },
  description: {
    color: "#8f897b",
    fontFamily: FontFamily.interRegular,
    fontSize: 15,
    fontStyle: "italic",
    lineHeight: 22.5,
    marginTop: 20,
    letterSpacing: 0.3,
  },
  subscribeButton: {
    borderRadius: 2,
    height: 40,
    maxWidth: "100%",
    width: "100%",
  },
  buttonWrap: {
    marginTop: 32,
    width: "100%",
  },
  subscribeButtonText: {
    fontFamily: FontFamily.interBold,
    fontSize: 13,
    fontWeight: "700",
    paddingHorizontal: 16,
    paddingVertical: 10,
    textTransform: "uppercase",
  },
  loginButton: {
    borderColor: "#8D7CFF",
    borderRadius: 2,
    borderWidth: 1,
    marginTop: 16,
    paddingVertical: 10,
    width: "100%",
  },
  loginButtonText: {
    color: "#2c2a24",
    fontFamily: FontFamily.interSemiBold,
    fontSize: 15,
    fontWeight: "600",
    textAlign: "center",
    display: "block",
  },
  links: {
    marginTop: 24,
  },
  linkItem: {
    marginTop: 14,
  },
  linkText: {
    color: "#8f897b",
    fontFamily: FontFamily.interRegular,
    fontSize: 15,
  },
});
